import React from 'react';
import CustomDialog from 'widgets/component/CustomDialog';
import DataTableDetailOrder from 'widgets/customDialogComponentDetails/ComponentDialog';

const STPDetailsDialog = ({
  open,
  onClose,
  detailsTransactionsSTP,
  handleOpenPopUp,
  setOpenActionFraud,
}) => {
  return (
    <CustomDialog
      fullWidth
      title={
        detailsTransactionsSTP?.response?.payment_info === null ? 'No hay datos' : 'Transacción STP'
      }
      content={
        <DataTableDetailOrder
          type='detailsSTP'
          handleOpenPopUp={handleOpenPopUp}
          setOpenActionFraud={setOpenActionFraud}
          response={detailsTransactionsSTP?.response}
          idTransaction={detailsTransactionsSTP?.response?.transaction_type?.transaction_id}
          onClose={onClose}
        />
      }
      open={open}
      onClose={onClose}
      maxWidth='md'
      extraButtons={[
        {
          label: 'Aceptar',
          variant: 'contained',
          onClick: onClose,
          buttonColor: 'purple',
          textColor: 'white',
        },
      ]}
    />
  );
};

export default STPDetailsDialog;
